import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Atom } from 'AppReact';
import { SwitchField } from './components';
import update from 'immutability-helper';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const SettingsButton = ({ priorities, onChange, allPriorities }) => {

  const [cards, setCards] = useState([]);
  const draggedCardRef = useRef(null);

  useEffect(() => {
    setCards(priorities?.sort((a, b) => a.index > b.index ? 1 : -1));
  }, [priorities])

  const move = useCallback((dragIndex, hoverIndex) => {
    const dragCard = cards[dragIndex];
    const targetIndex = cards[hoverIndex]?.index;
    draggedCardRef.current = { ...dragCard, index: targetIndex };
    setCards(update(cards, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragCard],
      ],
    }));
  }, [cards]);

  const save = () => {
    if (draggedCardRef.current) {
      const updatedCard = draggedCardRef.current;
      if (!updatedCard?.id) return;
      onChange({ priority: updatedCard, action: 'change_order' });
    }
  };

  const onDelete = (priority) => {
    onChange({ priority, action: 'delete' });
  }

  const onEdit = (priority) => {
    onChange({ priority, action: 'edit', allPriorities });
  }

  return (
    <DndProvider backend={HTML5Backend}>
      {cards.map((priority, index) => (
        <SwitchField
          key={priority?.name}
          priority={priority}
          hideDelete={priorities.length === 1}
          index={index}
          save={save}
          move={move}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ))}
    </DndProvider>
  )
}

export default Atom({ type: 'custom', dataType: 'string', template: SettingsButton });
